import { render, staticRenderFns } from "./repayment-schedule.vue?vue&type=template&id=0b6b3f72&scoped=true&"
import script from "./repayment-schedule.vue?vue&type=script&lang=js&"
export * from "./repayment-schedule.vue?vue&type=script&lang=js&"
import style0 from "./repayment-schedule.vue?vue&type=style&index=0&id=0b6b3f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b3f72",
  null
  
)

export default component.exports